import VoucherForm from './voucherForm'
import Subscriptions from './subscriptions'
import Player from './player'
import Page from './page'

export default Page
export { VoucherForm, Subscriptions, Player }
